var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fn-types-rating-input"},_vm._l((_vm.stars),function(rating,index){return _c('star-rating',_vm._g({key:index,attrs:{"id":`rating${rating}`,"name":_vm.name,"value":_vm.value,"input-value":rating,"disabled":_vm.disabled}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }